<script lang="ts">
  import { isLoggedIn } from '../utils/login.service.js';
  import { Link } from 'svelte-routing';
  import Icon from './Icon.svelte';
  import { OAuthSession } from '../utils/oauth-session.js';
  import { currentTool } from 'src/utils/store.js';
  import { onMount } from 'svelte';

  export let scopes: string[] = [];

  onMount(() => {
    currentTool.set(window.location.pathname.includes('routing') ? 'Routing' : 'Redirect');
  });
</script>

<header class="header">
  <div class="logo">
    <img src="./ADAC-Logo.svg" role="presentation" alt="" />
    <h1>U-Turn</h1>
    {#if $isLoggedIn && scopes.includes('routing') && scopes.includes('redirect')}
      <nav>
        <ul>
          <li class:selected={$currentTool === 'Redirect'}>
            <Link class="link" to="/" on:click={() => currentTool.set('Redirect')}
              ><h2>Redirect-Tool</h2></Link
            >
          </li>
          <li class:selected={$currentTool === 'Routing'}>
            <Link to="/routing" on:click={() => currentTool.set('Routing')}
              ><h2>Routing-Tool</h2></Link
            >
          </li>
        </ul>
      </nav>
    {:else if window.location.pathname === '/'}
      <h2 class="single-tool-h2">Redirect Tool</h2>
    {:else if window.location.pathname === '/routing'}
      <h2 class="single-tool-h2">Routing Tool</h2>
    {/if}
  </div>
  {#if $isLoggedIn}
    <a href={OAuthSession.getLogoutUrl()} class="logout-button"><Icon variant="logout" /></a>
  {/if}
</header>
<slot />

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';
  @use '../styles/font-sizes';

  .header {
    background-color: colors.$highlight;
    padding: spacing.$xs spacing.$s;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: inherit;
      align-items: center;
      gap: spacing.$s;

      img {
        height: 32px;
      }

      h1 {
        font-family: 'MiloSlabADAC';
        font-size: font-sizes.$heading-m;
      }
    }
  }

  .logout-button {
    padding: spacing.$xs;
    border-radius: spacing.$xxs;
    background: colors.$white100;
    border: 2px solid colors.$white100;

    &:hover {
      border-color: colors.$black90;
    }
  }

  :global(.header > .logout-button) {
    padding: spacing.$xxs spacing.$xs;
  }

  .single-tool-h2 {
    font-family: 'MiloSlabADAC';
    font-size: font-sizes.$heading-m;
    background-color: colors.$white100;
    padding: spacing.$xxs spacing.$xs;
  }

  nav {
    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: spacing.$xs spacing.$xs;
      background-color: colors.$white100;
      gap: spacing.$s;
      border-radius: 36px;

      li {
        padding: 8px;
        border-radius: 22px;
        transition: background-color 0.3s ease;
        :global(a) {
          color: colors.$black90;
          text-decoration: none;
        }

        h2 {
          font-family: 'MiloSlabADAC';
          font-size: font-sizes.$heading-s;
        }
      }

      li.selected {
        background-color: #ffd200; /* Yellow for the active link */
      }
    }
  }
</style>
